import React from 'react'
import ReactDOM from 'react-dom'
import Router from './Router.jsx'

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css'

ReactDOM.render(
  <React.StrictMode>
    <Router />
  </React.StrictMode >,
  document.getElementById('root')
)
